import network from '@/services/network';
import { AntragWizardData } from '@/store/application/types';

/**
 * Zwischenspeichern des Antrags-Wizards (BER-67). An Kunde + eingeloggten
 * Berater gebunden. `get` liefert `null`, wenn kein Entwurf existiert (204).
 */
export interface ApplicationDraft {
  payload: AntragWizardData;
  updated_at?: string;
}

const get = async (customerId: number): Promise<ApplicationDraft | null> => {
  const res = await network.get<{ data: ApplicationDraft }>(
    `/customers/${customerId}/application-draft`,
    { validateStatus: (s) => s === 200 || s === 204 },
  );
  if (res.status === 204) return null;
  return res.data.data;
};

const save = async (customerId: number, payload: AntragWizardData): Promise<void> => {
  await network.put(`/customers/${customerId}/application-draft`, { payload });
};

const remove = async (customerId: number): Promise<void> => {
  await network.delete(`/customers/${customerId}/application-draft`);
};

const applicationDraft = { get, save, remove };

export default applicationDraft;
